import React from "react";


export default function CommitteeMemberItem({
                                              id,
                                              title,
                                              phone,
                                              mobile_phone,
                                              email,
                                              region,
                                              headshot_uri,
                                              address_line1,
                                              address_line2,
                                              city,
                                              state: {
                                                abbreviation: stateAbbreviation = '',
                                                full: stateFull = ''
                                              } = {},
                                              zip,
                                              organization_representing,
                                              spouse_name
                                            }) {
  title = title.replace('&nbsp;', '').replace('&amp;', '&');
  const pathName = window.location.pathname;
  if (pathName === '/atae/member-directory' || pathName === '/atae/directory/member-directory') {
    return (<tr>
        <td><a href={"/committee_member/" + id}>{title}</a></td>
        <td>{organization_representing}</td>
        <td>{stateFull}</td>
        <td>
          {phone ? phone : null}
          <br/>
          {mobile_phone ? mobile_phone : null}
        </td>
      </tr>
    );
  }
  else {
    return (
      <div className="mb-24 flex flex-col">
        <p
          className="mb-4 text-secondary uppercase text-xxs font-bold tracking-widest">
          {stateFull}
        </p>
        {headshot_uri ? (
          <div className="rounded-full mb-3 overflow-hidden">
            <div className="cover-image">
              <img src={headshot_uri} alt={`Headshot of ${title}`}/>
            </div>
          </div>
        ) : null}
        <h3 className="text-xl">
          <div>{title}</div>
        </h3>
        <div className="text-lg text-gray-700">
          {region ? (
            <p className="text-sm">
              <span className="font-bold">Region: </span>
              {region}
            </p>
          ) : null}
          <p className="text-sm">
            <span className="font-bold">Association: </span>
            {organization_representing}
          </p>
          {address_line1 ? (
            <p className="text-sm flex whitespace-pre-wrap">
              <span className="font-bold">Address: </span>
              <span className="flex flex-col">
							{address_line1 ? <span>{address_line1}</span> : null}
                {address_line2 ? <span>{address_line2}</span> : null}
						</span>
            </p>
          ) : null}
          {city ? (
            <p className="text-sm">
              <span className="font-bold">City: </span>
              {city}
            </p>
          ) : null}
          <p className="text-sm">
            <span className="font-bold">State: </span>
            {stateFull}
          </p>
          <p className="text-sm">
            <span className="font-bold">Zip: </span>
            {zip}
          </p>
          {phone ? (
            <p className="text-sm">
              <span className="font-bold">Phone: </span>
              <a className="no-underline text-inherit" href={`tel:${phone}`}>
                {phone}
              </a>
            </p>
          ) : null}
          {mobile_phone ? (
            <p className="text-sm">
              <span className="font-bold">Mobile Phone: </span>
              <a className="no-underline text-inherit"
                 href={`tel:${mobile_phone}`}>
                {mobile_phone}
              </a>
            </p>
          ) : null}
          {email ? (
            <p className="text-sm">
              <span className="font-bold">Email: </span>
              {email}
            </p>
          ) : null}
          {spouse_name ? (
            <p className="text-sm">
              <span className="font-bold">Spouse Name: </span>
              {spouse_name}
            </p>
          ) : null}
        </div>
      </div>
    );
  }
  return (
    <div className="mb-8 max-w-2xl">
      {!!contentTopic ? (
        <span className="text-primary text-xs uppercase">{contentTopic}</span>
      ) : null}
      {!!title ? (
        <a
          href={path}
          className="block mt-2 mb-4 text-black text-xl no-underline font-bold"
        >
          {title}
        </a>
      ) : null}
      {!!summary ? <div className="text-coolGray-400">{summary}</div> : null}
    </div>
  );
}
